import React, { memo, ReactNode } from 'react';
import { isMobileApp } from 'flow/utils/app-utils';

import './css/ContentWrapper.css';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    children: ReactNode;
    backgroundStyle?: 'filled' | 'neutral';
    className?: string;
}

const ContentWrapper = memo(
    ({ children, backgroundStyle = 'filled', className }: Props) => {
        const { embedded } = useAppContext();
        const isFilled = !isMobileApp(embedded) && backgroundStyle === 'filled';

        return (
            <div
                id="content-wrapper"
                className={twMerge(
                    'flex w-full flex-nowrap overflow-y-hidden',
                    isFilled ? 'bg-white' : 'bg-gray-150',
                    className,
                )}
            >
                {children}
            </div>
        );
    },
);

export default ContentWrapper;
